import {
  Box,
  Button,
  CircularProgress,
  Grid2,
  IconButton,
  Tooltip,
} from "@mui/material";
import React, { useState, useEffect, useRef } from "react";
import SideBar from "../SideBar/SideBar";
import { useTheme, useMediaQuery } from "@mui/material";
import "../Assistant/Assistant.css";
import "./../CallHistory/CallHistory.css";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import Modal from "@mui/material/Modal";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import DeleteIcon from "@mui/icons-material/Delete";
import { ToastContainer, toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
// import './ContactList.css'
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import TablePagination from "@mui/material/TablePagination";
import TuneIcon from "@mui/icons-material/Tune";

import Slider from "@mui/material/Slider";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import VolumeDownIcon from "@mui/icons-material/VolumeDown";
import SmartToyIcon from "@mui/icons-material/SmartToy";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { useLocation } from "react-router-dom";
import { getCallHistoryDetail } from "../../services/CallHistory";
import dayjs from "dayjs";
import Loader from "../Loader";
import PauseIcon from "@mui/icons-material/Pause";
import VolumeUpIcon from "@mui/icons-material/VolumeUp";

const drawerWidth = 300;
const CampaignDetails = () => {
  const notify = () => toast.success("Setup Completed");
  const remove = () => toast.success("Deleted successfully");

  const theme = useTheme();
  const isLgUp = useMediaQuery(theme.breakpoints.up("sm"));

  const [pop, setPop] = useState(false);
  const handlePopOpen = () => setPop(true);
  const handlePopClose = () => setPop(false);

  const navigate = useNavigate();
  const location = useLocation();

  const [callHistoryDetail, setCallHistoryDetail] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const audioRef = useRef(null); // Reference for the audio element

  const [isPlaying, setIsPlaying] = useState(false);
  const [volume, setVolume] = useState(100); // Volume slider value (0-100)
  const [currentTime, setCurrentTime] = useState(0); // Current time of the audio
  const [duration, setDuration] = useState(0);
  const [personalDetail, setPersonDetail] = useState({});

  useEffect(() => {
    const callId = location?.state?.id;
    getCallDetail(callId);
    const dateCalculation = new Date(location?.state?.date);
    const formattedDate = dateCalculation?.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric', });
    setPersonDetail({
      customerName: location?.state?.customerName,
      status: location?.state?.status,
      date: formattedDate,
    });
  }, []);

  const getCallDetail = async (callId) => {
    setIsLoading(true);
    const response = await getCallHistoryDetail(callId);
    if (response?.data?.success === true) {
      const data = response.data.result;
      setCallHistoryDetail(response.data.result);
      setIsLoading(false);
    } else {
      setIsLoading(false);
    }
  };
  const formatCallDuration = (duration) => {
    // Split the input duration like "1min:12secs" into components
    // setIsLoading(true);
    const [minutes, seconds] = duration
      ?.split(":")
      ?.map((str) => parseInt(str));

    // Return the formatted string
    return `${minutes} min ${seconds} secs`;
    // setIsLoading(false);
  };

 

  const formatTimestamp = (timestamp) => {
    return dayjs(timestamp).format("h:mm:ss A"); // Format as "HH:mm A"
  };

  const copyChatData = () => {
    // Format the chat data
    let chatText = "";
    callHistoryDetail?.transcript?.forEach((message) => {
      chatText += `[${formatTimestamp(message.timestamp)}] ${
        message.speaker === "assitant" ? "Assistant" : "User"
      }: ${message.text}\n`;
    });

    // Copy to clipboard
    navigator.clipboard
      .writeText(chatText)
      .then(() => {
        //   alert('Chat copied to clipboard!');
        toast.success("Chat copied to clipboard!");
      })
      .catch((err) => {
        console.error("Failed to copy: ", err);
      });
  };
  const [muted, setMuted] = useState(false); // Manage mute state

  const handlePlayPause = () => {
    if (isPlaying) {
      audioRef.current.pause();
    } else {
      audioRef.current.play();
    }
    setIsPlaying(!isPlaying);
  };

  const handleMuteToggle = () => {
    setMuted(!muted);
    audioRef.current.muted = !muted; // Toggle mute
  };

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${mins}:${secs < 10 ? "0" : ""}${secs}`;
  };

  const handleSliderChange = (event, newValue) => {
    audioRef.current.currentTime = newValue;
    setCurrentTime(newValue);
  };
  const [isLoadingAudio, setIsLoadingAudio] = useState(true);

  const handleLoadedMetadata = (e) => {
    setIsLoadingAudio(true);
    setDuration(e.target.duration); // Set the duration once metadata is loaded
    setIsLoadingAudio(false); // Hide the loading spinner once metadata is available
  };

  const handleCanPlayThrough = () => {
    // This ensures the audio is fully buffered and can play without buffering
    setIsLoadingAudio(true);
    if (audioRef.current) {
      setIsLoadingAudio(false); // Set loading state to false when audio is ready to play
    }
  };

  const handleTimeUpdate = (e) => {
    setCurrentTime(e.target.currentTime); // Update current time as audio plays
  };

  if (isLoading) return <Loader />;

  return (
    <div className="CampaignDetails">
      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
        // transition={Bounce}
      />
      {/* {isLoading===true && <Loader/>} */}
      {/* <Box sx={{ display: isLgUp ? "flex" : "block", marginTop: "20px" }}>
        <SideBar /> */}

      {/* {isLoading===true ? (
          <Loader />
        ) : ( */}
      {/* <Box
            component="main"
            sx={{
              flexGrow: 1,
              p: isLgUp ? 5 : 1,
              width: { sm: `calc(100% - ${drawerWidth}px)` },
              marginTop: isLgUp ? "50px" : "80px",
            }}
          > */}
      <div className="display-1">
        {/* <h2>Shyam</h2> */}
        <h2>{personalDetail?.customerName}</h2>
      </div>

      <Grid2 container spacing={4}>
        <Grid2
          item
          size={{ xs: 12, sm: 12, md: 7, lg: 7, xl: 7 }}
          sx={{
            background: "#fff",
            padding: "30px",
            border: "2px solid #8087D7",
            borderRadius: "15px",
          }}
        >
          <div className="heading-line">
            <Typography variant="h6" component="h6">
              <b>Details</b>
            </Typography>
          </div>
          <div className="details mt-10">
            <div>
              <Typography variant="p" component="p" sx={{ paddingTop: "5px" }}>
                Call Duration
              </Typography>
              <Typography variant="p" component="p" sx={{ paddingTop: "5px" }}>
                Date
              </Typography>
              <Typography variant="p" component="p" sx={{ paddingTop: "5px" }}>
                Starting time
              </Typography>
              <Typography variant="p" component="p" sx={{ paddingTop: "5px" }}>
                Ending time
              </Typography>
              <Typography variant="p" component="p" sx={{ paddingTop: "5px" }}>
                Customer name
              </Typography>
              <Typography variant="p" component="p" sx={{ paddingTop: "5px" }}>
                Status
              </Typography>
            </div>
            <div>
              <Typography variant="p" component="p" sx={{ paddingTop: "5px" }}>
                :
              </Typography>
              <Typography variant="p" component="p" sx={{ paddingTop: "5px" }}>
                :
              </Typography>
              <Typography variant="p" component="p" sx={{ paddingTop: "5px" }}>
                :
              </Typography>
              <Typography variant="p" component="p" sx={{ paddingTop: "5px" }}>
                :
              </Typography>
              <Typography variant="p" component="p" sx={{ paddingTop: "5px" }}>
                :
              </Typography>
              <Typography variant="p" component="p" sx={{ paddingTop: "5px" }}>
                :
              </Typography>
            </div>
            <div>
              <Typography variant="p" component="p" sx={{ paddingTop: "5px" }}>
                {formatCallDuration(callHistoryDetail?.callduration)}
              </Typography>
              <Typography variant="p" component="p" sx={{ paddingTop: "5px" }}>
                {/* 15 dec 2025 */}
                {personalDetail?.date}
              </Typography>
              <Typography variant="p" component="p" sx={{ paddingTop: "5px" }}>
                4:15:10pm
              </Typography>
              <Typography variant="p" component="p" sx={{ paddingTop: "5px" }}>
                5:15:10pm
              </Typography>
              <Typography variant="p" component="p" sx={{ paddingTop: "5px" }}>
                {personalDetail?.customerName}
              </Typography>
              <Typography variant="p" component="p" sx={{ paddingTop: "5px" }}>
                {personalDetail?.status}{" "}
              </Typography>
            </div>
          </div>

          {/* <Box
                  className="slider mt-20 mb-20"
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    backgroundColor: "#ECE0FF",
                    width: "250px",
                    alignItems: "center",
                  }}
                >
                  <PlayArrowIcon />
                  <Typography
                    variant="p"
                    component="p"
                    sx={{ fontSize: "10px" }}
                  >
                    45:30
                  </Typography>
                  <Slider
                    value={50}
                    color="##E6C7FF"
                    aria-labelledby="input-slider"
                  />
                  <VolumeDownIcon />
                  <Typography
                    variant="p"
                    component="p"
                    sx={{ fontSize: "10px" }}
                  >
                    :
                  </Typography>
                </Box> */}
          {formatCallDuration(callHistoryDetail?.callduration) !==
            "0 min 0 secs" && (
            <div className="call-recording-play">
              <div className="heading-line mt-20">
                <Typography variant="h6" component="h6">
                  <b>Call Recording</b>
                </Typography>
              </div>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "30px",
                  marginTop: "20px",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    backgroundColor: "#ECE0FF",
                    padding: "5px 20px",
                    borderRadius: "10px",
                  }}
                >
                  <div
                    onClick={handlePlayPause}
                    style={{ cursor: "pointer" }}
                  >
                 

                    {isLoadingAudio === true ? (
                      <div className="loading-svg">
                        {" "}
                        <Tooltip title="Click to see loading">
                          {" "}
                          <IconButton
                            loading={isLoadingAudio}
                          ></IconButton>{" "}
                        </Tooltip>
                      </div>
                    ) : isPlaying ? (
                      <PauseIcon />
                    ) : (
                      <PlayArrowIcon />
                    )}
                  </div>

                  <Typography variant="body2" sx={{ margin: "0 10px" }}>
                    {formatTime(currentTime)} / {formatTime(duration)}
                  </Typography>

                  <Slider
                    value={currentTime}
                    min={0}
                    max={duration}
                    onChange={handleSliderChange}
                    sx={{ width: "100px" }}
                  />

                  <div
                    onClick={() => handleMuteToggle()}
                    style={{ cursor: "pointer" }}
                  >
                    {muted ? <VolumeDownIcon /> : <VolumeUpIcon />}
                  </div>
                </Box>

                <audio
                  ref={audioRef}
                  src={callHistoryDetail?.recording} // Replace with the actual URL of the audio file
                
                  onCanPlayThrough={handleCanPlayThrough} // Trigger once audio is fully buffered
                  onLoadedMetadata={handleLoadedMetadata} // Trigger when metadata is loaded (duration available)
                  onTimeUpdate={handleTimeUpdate}
                  preload="auto"
                />
              </Box>
            </div>
          )}
          {/* <div className="heading-line mt-20">
            <Typography variant="h6" component="h6">
              <b>Post Call Analysis</b>
            </Typography>
          </div>
          <div className="details mt-20">
            <Typography variant="h6" component="h6">
              Question
            </Typography>
            <Typography variant="h6" component="h6">
              Answer
            </Typography>
          </div>
          <div className="details mt-10">
            <Typography variant="p" component="p">
              1. was the user interested in buying the products
            </Typography>
            <Typography variant="p" component="p" className="green">
              yes
            </Typography>
          </div>
          <div className="details mt-10">
            <Typography variant="p" component="p">
              2. was the user interested in buying the products
            </Typography>
            <Typography variant="p" component="p" className="red">
              no
            </Typography>
          </div>
          <div className="heading-line mt-20">
            <Typography variant="h6" component="h6">
              <b>Entities Extracted</b>
            </Typography>
          </div>
          <Stack
            direction="row"
            spacing={1}
            className="mt-20"
            sx={{
              justifyContent: "space-between",
              flexDirection: { xs: "column", md: "row", lg: "row" },
            }}
          >
            <Typography variant="p" component="p">
              <b>E-mail:</b>shyam@gmail.com
            </Typography>
            <Typography variant="p" component="p">
              <b>Address:</b>chennai, tamil nadu
            </Typography>
          </Stack>
          <Stack
            direction="row"
            spacing={1}
            className="mt-10"
            sx={{
              justifyContent: "space-between",
              flexDirection: { xs: "column", md: "row", lg: "row" },
            }}
          >
            <Typography variant="p" component="p">
              <b>Name:</b>shyam
            </Typography>
            <Typography variant="p" component="p">
              <b>Phone number:</b>8593028472
            </Typography>
          </Stack> */}
        </Grid2>
        <Grid2 item size={{ xs: 12, sm: 12, md: 5, lg: 5, xl: 5 }}>
          {/* <Box className="trascript" sx={{ borderRadius: "10px", display: "flex", flexDirection: "column", }}>
                                <Box sx={{ display: "flex", flexDirection: "row", justifyContent: "space-between ", backgroundColor: "#2F024E", padding: "15px", borderTopLeftRadius: "10px", alignItems: "center", borderTopRightRadius: "10px" }}>
                                    <Typography variant='body2' color='white'>Trascript</Typography>
                                    <ContentCopyIcon sx={{ color: "white" }} />

                                </Box>
                                <Box className="chatbox" sx={{ display: 'flex', flexDirection: "column", padding: "0.5rem", height: '60vh', overflow: 'scroll', border: "2px solid #8087D7", borderRadius: '0px 0px 15px 15px' }}>
                                    <Stack direction="row" spacing={1} className="mt-10" sx={{ justifyContent: 'end' }} >
                                        <Typography textAlign="right" variant='body1' sx={{ backgroundColor: "#FFFFFF", padding: "5px 10px", borderRadius: "15px", fontSize: '12px', maxWidth: "60%" }}>hello</Typography>
                                        <SmartToyIcon sx={{ color: "cadetblue" }} />
                                    </Stack>
                                    <Stack direction="row" spacing={1} className="mt-10" sx={{ justifyContent: 'start' }} >
                                        <AccountCircleIcon sx={{ color: "cadetblue" }} />
                                        <Typography textAlign="start" variant='body1' sx={{ backgroundColor: "#E6C7FF", padding: "5px 10px", borderRadius: "15px", fontSize: '12px', maxWidth: "60%" }}>This is Bot name from company. How is your day day?</Typography>
                                    </Stack>

                                    <Stack direction="row" spacing={1} className="mt-10" sx={{ justifyContent: 'end' }} >
                                        <Typography textAlign="right" variant='body1' sx={{ backgroundColor: "#FFFFFF", padding: "5px 10px", borderRadius: "15px", fontSize: '12px', maxWidth: "60%" }}>hello</Typography>
                                        <SmartToyIcon sx={{ color: "cadetblue" }} />
                                    </Stack>
                                    <Stack direction="row" spacing={1} className="mt-10" sx={{ justifyContent: 'start' }} >
                                        <AccountCircleIcon sx={{ color: "cadetblue" }} />
                                        <Typography textAlign="start" variant='body1' sx={{ backgroundColor: "#E6C7FF", padding: "5px 10px", borderRadius: "15px", fontSize: '12px', maxWidth: "60%" }}>hello</Typography>
                                    </Stack>
                                </Box>




                            </Box> */}

          <Box
            className="trascript"
            sx={{
              borderRadius: "10px",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                backgroundColor: "#2F024E",
                padding: "25px 15px",
                borderTopLeftRadius: "10px",
                alignItems: "center",
                borderTopRightRadius: "10px",
              }}
            >
              <Typography variant="body2" color="white">
                Transcript
              </Typography>
              <div onClick={() => copyChatData()} style={{ cursor: "pointer" }}>
                <ContentCopyIcon sx={{ color: "white" }} />
              </div>
            </Box>

            <Box
              className="chatbox"
              sx={{
                display: "flex",
                flexDirection: "column",
                padding: "0.5rem",
                height: "60vh",
                overflowY: "scroll",
                border: "2px solid #8087D7",
                borderRadius: "0px 0px 15px 15px",
              }}
            >
              {callHistoryDetail?.transcript.length === 0 && (
                <h4 style={{ textAlign: "center" }}>
                  Transcript not available!
                </h4>
              )}
              {callHistoryDetail?.transcript?.length > 0 &&
                callHistoryDetail?.transcript?.map((message) => (
                  <Box key={message._id} sx={{ marginBottom: "10px" }}>
                    <Typography
                      variant="caption"
                      sx={{
                        color: "gray",
                        display: "flex",
                        justifyContent: "center",
                        padding: "8px",
                      }}
                    >
                      {formatTimestamp(message.timestamp)}
                    </Typography>

                    <Stack
                      direction="row"
                      spacing={1}
                      sx={{
                        justifyContent:
                          message.speaker === "assitant"
                            ? "flex-end"
                            : "flex-start",
                      }}
                    >
                      {message.speaker === "user" && (
                        <AccountCircleIcon sx={{ color: "cadetblue" }} />
                      )}

                      <Typography
                        textAlign={
                          message.speaker === "assitant" ? "right" : "left"
                        }
                        variant="body1"
                        sx={{
                          backgroundColor:
                            message.speaker === "assitant"
                              ? "#FFFFFF"
                              : "#E6C7FF",
                          padding: "5px 10px",
                          borderRadius: "15px",
                          fontSize: "12px",
                          maxWidth: "60%",
                        }}
                      >
                        {message.text}
                      </Typography>
                      {message.speaker === "assitant" && (
                        <SmartToyIcon sx={{ color: "cadetblue" }} />
                      )}
                    </Stack>
                  </Box>
                ))}
            </Box>
          </Box>
        </Grid2>
      </Grid2>
      {/* </Box>
        )} */}
      {/* </Box> */}
    </div>
  );
};

export default CampaignDetails;
